import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentationWorkflowStateUpdateStore } from "../../store";
import { EditionDocumentationWorkflowStateUpdateForm } from "./EditionDocumentationWorkflowStateUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type EditionDocumentationWorkflowStateUpdateProps = {
  editionDocumentationWorkflowStateUpdateStore: EditionDocumentationWorkflowStateUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EditionDocumentationWorkflowStateUpdate: React.FC<EditionDocumentationWorkflowStateUpdateProps> =
  observer(
    ({
      editionDocumentationWorkflowStateUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={editionDocumentationWorkflowStateUpdateStore.isSaving}
          />
          <OutdatedAfterSaveNotice
            open={editionDocumentationWorkflowStateUpdateStore.savedButOutdated}
            onReload={() =>
              editionDocumentationWorkflowStateUpdateStore.reloadEditionDocumentationWorkflowState()
            }
            reloadDisabled={
              editionDocumentationWorkflowStateUpdateStore.isProcessing
            }
          />
          <EditionDocumentationWorkflowStateUpdateForm
            editionDocumentationWorkflowStateUpdateStore={
              editionDocumentationWorkflowStateUpdateStore
            }
            name_esError={
              editionDocumentationWorkflowStateUpdateStore.errors.name_es
                ?.message
            }
            onName_esChange={(value: string) => {
              editionDocumentationWorkflowStateUpdateStore.setName_esValue(
                value
              );
            }}
            name_es={
              editionDocumentationWorkflowStateUpdateStore.entityValues.name_es
            }
            name_enError={
              editionDocumentationWorkflowStateUpdateStore.errors.name_en
                ?.message
            }
            onName_enChange={(value: string) => {
              editionDocumentationWorkflowStateUpdateStore.setName_enValue(
                value
              );
            }}
            name_en={
              editionDocumentationWorkflowStateUpdateStore.entityValues.name_en
            }
            name_ptError={
              editionDocumentationWorkflowStateUpdateStore.errors.name_pt
                ?.message
            }
            onName_ptChange={(value: string) => {
              editionDocumentationWorkflowStateUpdateStore.setName_ptValue(
                value
              );
            }}
            name_pt={
              editionDocumentationWorkflowStateUpdateStore.entityValues.name_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={editionDocumentationWorkflowStateUpdateStore.saveDisabled}
            onSave={() =>
              editionDocumentationWorkflowStateUpdateStore.saveEditionDocumentationWorkflowState()
            }
            onCancel={() =>
              editionDocumentationWorkflowStateUpdateStore.cancelEditionDocumentationWorkflowState()
            }
          />
          <ErrorDialog
            open={
              editionDocumentationWorkflowStateUpdateStore.errorDialogOpened
            }
            title={editionDocumentationWorkflowStateUpdateStore.errorTitle}
            description={
              editionDocumentationWorkflowStateUpdateStore.errorDescription
            }
            onClose={() =>
              editionDocumentationWorkflowStateUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={
              editionDocumentationWorkflowStateUpdateStore.confirmDialogOpened
            }
            title={
              editionDocumentationWorkflowStateUpdateStore.confirmDialogTitle
            }
            description={
              editionDocumentationWorkflowStateUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              editionDocumentationWorkflowStateUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              editionDocumentationWorkflowStateUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
